import { render } from "./MakingOrder.vue?vue&type=template&id=6dc811c2&scoped=true"
import script from "./MakingOrder.vue?vue&type=script&lang=js"
export * from "./MakingOrder.vue?vue&type=script&lang=js"

import "./MakingOrder.vue?vue&type=style&index=0&id=6dc811c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc811c2"]])

export default __exports__